import { getCashFlow } from "../../apiClient";
import { formatDateForAPI } from "../dateUtils";
import { groupCashFlowByCategory, sumCashFlowByCategory } from "../collectionUtils";
import { pickDimensionFilters } from "../dimensionParams";
import { formatReportApiError, isRequestCancelled } from "../errorUtils";
import { getMockReportData } from "../mockData";

export const formatCashFlowData = (data) => {
  if (!data) {
    return null;
  }

  const operatingCash = sumCashFlowByCategory(data.operating || []);
  const investingCash = sumCashFlowByCategory(data.investing || []);
  const financingCash = sumCashFlowByCategory(data.financing || []);

  return {
    totals: {
      operatingCash,
      investingCash,
      financingCash,
      netCashFlow: operatingCash + investingCash + financingCash,
    },
    details: {
      operating: groupCashFlowByCategory(data.operating || []),
      investing: groupCashFlowByCategory(data.investing || []),
      financing: groupCashFlowByCategory(data.financing || []),
    },
  };
};

export const handleCashFlow = async (filters, periodDate, firstDayOfMonth, language = "ar", options = {}) => {
  try {
    const params = {
      currency: filters.currency,
      date_after: formatDateForAPI(firstDayOfMonth),
      date_before: formatDateForAPI(periodDate),
      compare_period_unit: filters.compare_period_unit || "month",
      ...pickDimensionFilters(filters),
    };

    if (filters.cash_flow_type) {
      params.cash_flow_type = filters.cash_flow_type;
    }

    const apiResponse = await getCashFlow(params, { signal: options.signal });

    return {
      success: true,
      reportType: "cashFlow",
      isRealData: true,
      originalData: apiResponse.data,
      data: formatCashFlowData(apiResponse.data),
    };
  } catch (error) {
    if (isRequestCancelled(error)) throw error;
    console.error("CashFlow API Error:", error);
    return {
      success: false,
      reportType: "cashFlow",
      isRealData: false,
      data: getMockReportData("cashFlow", filters),
      error: formatReportApiError(error, language),
    };
  }
};
